module.exports = __webpack_public_path__ + "static/img/wrj3.f2319c15.png";